import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/network/(pages)')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/network' || location.pathname === '/network/') {
      throw redirect({ to: '/network/my-network' });
    }
  },
});
